import * as React from 'react';
import styled from 'styled-components';

const BannerContainer = styled.div`
  background: linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%);
  color: white;
  padding: 15px 20px;
  border-radius: 8px;
  margin: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 15px;
  box-shadow: 0 4px 12px rgba(238, 90, 111, 0.3);
  animation: pulse 2s infinite;

  @keyframes pulse {
    0%, 100% {
      box-shadow: 0 4px 12px rgba(238, 90, 111, 0.3);
    }
    50% {
      box-shadow: 0 4px 20px rgba(238, 90, 111, 0.5);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
  }
`;

const IconWrapper = styled.div`
  i {
    font-size: 32px;
  }
`;

const Content = styled.div`
  flex: 1;
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 18px;
  margin-bottom: 5px;
`;

const Description = styled.div`
  font-size: 14px;
  opacity: 0.95;
`;

const Timer = styled.div`
  background: rgba(0, 0, 0, 0.2);
  padding: 10px 20px;
  border-radius: 6px;
  font-family: 'Courier New', monospace;
  font-size: 20px;
  font-weight: bold;
  min-width: 100px;
  text-align: center;
`;

export const UrgencyBanner: React.FC = () => {
  const [timeLeft, setTimeLeft] = React.useState({
    minutes: 14,
    seconds: 59,
  });

  React.useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { minutes: prev.minutes - 1, seconds: 59 };
        } else {
          return { minutes: 0, seconds: 0 };
        }
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <BannerContainer>
      <IconWrapper>
        <i className="material-icons">local_fire_department</i>
      </IconWrapper>
      <Content>
        <Title>Oferta por Tempo Limitado!</Title>
        <Description>Complete sua compra e garanta o melhor preço</Description>
      </Content>
      <Timer>
        {String(timeLeft.minutes).padStart(2, '0')}:{String(timeLeft.seconds).padStart(2, '0')}
      </Timer>
    </BannerContainer>
  );
};

